import { render, staticRenderFns } from "./ApiInvoiceForm.vue?vue&type=template&id=047adc37"
import script from "./ApiInvoiceForm.vue?vue&type=script&lang=js"
export * from "./ApiInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports